import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import showNotification from './extras/showNotification';

interface GoogleLoginButtonProps {
  onSuccess: (idToken: string) => Promise<void>;
  onError?: (error: string) => void;
  disabled?: boolean;
}

/**
 * GoogleLoginButton — Tombol Sign In with Google.
 * Menggunakan GoogleLogin component dari @react-oauth/google.
 */
const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
  onSuccess,
  onError,
  disabled = false,
}) => {
  // Cek apakah Google Client ID sudah dikonfigurasi
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  if (!clientId) {
    return (
      <div
        style={{
          width: '100%',
          maxWidth: '320px',
          margin: '0 auto',
          padding: '10px 16px',
          borderRadius: '8px',
          background: '#fef2f2',
          border: '1px solid #fecaca',
          textAlign: 'center',
          fontSize: '0.8rem',
          color: '#dc2626',
        }}
      >
        ⚠️ Google Sign-In belum dikonfigurasi.<br />
        <span style={{ fontSize: '0.7rem', color: '#9ca3af' }}>
          Set <strong>REACT_APP_GOOGLE_CLIENT_ID</strong> di file .env
        </span>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      {disabled ? (
        <div
          style={{
            width: '100%',
            maxWidth: '320px',
            height: '40px',
            borderRadius: '8px',
            background: '#f3f4f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.85rem',
            color: '#9ca3af',
            cursor: 'not-allowed',
          }}
        >
          Memproses...
        </div>
      ) : (
        <GoogleLogin
          onSuccess={async (credentialResponse) => {
            const idToken = credentialResponse.credential;
            if (!idToken) {
              showNotification('Error', 'Google tidak mengembalikan token', 'danger');
              onError?.('No credential returned from Google');
              return;
            }
            try {
              await onSuccess(idToken);
            } catch {
              // Error sudah dihandle di parent
            }
          }}
          onError={() => {
            showNotification('Error', 'Google Sign-In gagal. Silakan coba lagi.', 'danger');
            onError?.('Google Sign-In failed');
          }}
          theme="outline"
          size="large"
          text="signin_with"
          shape="rectangular"
          width="320"
          logo_alignment="center"
        />
      )}
    </div>
  );
};

export default GoogleLoginButton;
